import _ from '@lodash';
import { Slide } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import React from 'react';
import AnotacaoForm from '../AnotacaoForm/AnotacaoForm';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function AnotacaoDialog(props) {

    return (
        <XAPPDialog
            id="Anotacao"
            classes={{
                paper: "w-full m-24 rounded-8"
            }}
            TransitionComponent={Transition}
            onClose={() => props.openDialog(null)}
            open={!_.isNull(props.open)}
        >
            <AnotacaoForm
                anotacao={props.open}
                onCreate={props.handleChangeAnotacoes}
                onClose={() => props.openDialog(null)}
            />
        </XAPPDialog>
    );
}

export default AnotacaoDialog;
